import { render, staticRenderFns } from "./abandoned.vue?vue&type=template&id=78e2d14f&scoped=true&"
import script from "./abandoned.vue?vue&type=script&lang=js&"
export * from "./abandoned.vue?vue&type=script&lang=js&"
import style0 from "./abandoned.vue?vue&type=style&index=0&id=78e2d14f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e2d14f",
  null
  
)

export default component.exports